export default __webpack_public_path__ + "static/media/Montserrat-Bold.d0ca82d8.ttf";